import { UserFilters } from '../../interfaces/interfaces';
import { userFilterDefaults } from '../../utilities/stateUtils';
import { baseRealEstateUrl } from '@capcenter/shared';

const marketingSubscriptionUrl = baseRealEstateUrl + '/webforms/api/v1/marketingsubscription';
//const marketingSubscriptionUrl = 'http://localhost:3045/api/v1/marketingsubscription';

const getValidFilterItemsAndConvertToSearchFormat = (filters: UserFilters) => {

	const searchFilters: object[] = [];
	Object.keys(filters).forEach(filterKey => {

		if (filterKey === 'initialized')
			return;

		const filterType = filterKey;
		const filterValue = filters[filterKey as keyof UserFilters];

		if (filterValue === userFilterDefaults[filterKey as keyof UserFilters])
			return;

		const filter = {
			filterType: filterType,
			filterValue: filterValue
		};

		searchFilters.push(filter);

	});

	return searchFilters;
};


export const createSavedSearchAlert = async (clientName: string, email: string, phone: string, zip: string, filters: UserFilters) => {


	const marketingSubscriptionRequestBody: any = {
		firstName: clientName,
		email: email,
		leadSource: 'Homesearch',
		zipCode: zip,
		telephone: phone 
	};

	const nameSplit = clientName.split(/\s/);

	if (nameSplit.length === 2) {
		marketingSubscriptionRequestBody.firstName = nameSplit[0];
		marketingSubscriptionRequestBody.lastName = nameSplit[1];
	} else if (nameSplit.length >= 3) {
		marketingSubscriptionRequestBody.firstName = nameSplit.shift();
		marketingSubscriptionRequestBody.lastName = nameSplit.join(' ');
	}

	const marketingSubscriptionRequestOptions: RequestInit = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(marketingSubscriptionRequestBody)
	};

	const marketingSubscriptionResponse = await window.fetch(marketingSubscriptionUrl, marketingSubscriptionRequestOptions);
	const marketingSubscriptionResponseBody = await marketingSubscriptionResponse.json();

	// const searchFilters = getValidFilterItemsAndConvertToSearchFormat(filters);

	// const search = {
	// 	client: client,
	// 	emails: [email],
	// 	filters: searchFilters,
	// 	createdBy: client,
	// 	createdDate: new Date(),
	// 	updatedBy: client,
	// 	updatedDate: new Date(),
	// 	url: window.location.href
	// };

	// const bodyInit: BodyInit = JSON.stringify(search);

	// const requestOptions: RequestInit = {
	// 	method: 'POST',
	// 	headers: {
	// 		'Content-Type': 'application/json'
	// 	},
	// 	body: bodyInit
	// };
	// console.log('not sending', requestOptions);

	//const realtyApiUrl = 'localhost:3010/v1/';
	//const savedSearchAlertPostResponse = await window.fetch('http://localhost:3010/v1/search', requestOptions);


	//console.log(savedSearchAlertPostResponse);

	return true;
};
